import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    OrderStatuses, OrderTypes, ProductType,
} from 'app/enums/label.enums'
import SkyNetLink, {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    FilterType,
} from 'app/enums/common.enums'

import {
    TruckingCapacityOutbound,
} from './relatedOrders.types'

export default ({
    getOrderLink,
    linkStyle,
}: {
    getOrderLink: (orderNumber: string, orderType: OrderTypes) => string,
    linkStyle: string,
}): SkyNetTableConfig<keyof TruckingCapacityOutbound> => {
    return {
        name: 'RelatedOrders-OutboundOrder',
        fields: [
            {
                name: 'orderNumber',
                width: '160px',
                mapCellProps: ({
                    orderType,
                    orderNumber,
                }) => {
                    return {
                        value: orderNumber,
                        link: getOrderLink(orderNumber, orderType),
                        type: TypeLink.EXTERNAL,
                        size: SizeLink.S,
                        className: linkStyle,
                    }
                },
                Cell: SkyNetLink,
                labelKey: 'DailyOpsView.orderNumber',
            },
            {
                name: 'orderStatus',
                componentName: 'EnumValue',
                allowedValuesEnum: OrderStatuses,
                labelKey: 'DailyOpsView.orderStatus',
            },
            {
                name: 'orderType',
                componentName: 'EnumValue',
                allowedValuesEnum: OrderTypes,
                labelKey: 'Order.orderType',
                filterField: 'orderType',
                filterType: FilterType.Array,
            },
            {
                name: 'from',
                labelKey: 'OrderBaseTabView.from',
            },
            {
                name: 'to',
                labelKey: 'DailyOpsView.to',
            },
            {
                name: 'customerLocationName',
                labelKey: 'Order.customer',
            },
            {
                name: 'pricingAccountCompanyName',
                labelKey: 'Prebooking.pricingAccount',
            },
            {
                name: 'estimatedDelivery',
                sorting: false,
                labelKey: 'OrderStep.estimatedPickup',
            },
            {
                name: 'requiredContainers',
                componentName: 'RequiredContainersList',
                allowedValuesEnum: ProductType,
                sorting: false,
                labelKey: 'Order.requiredContainers',
                filterField: 'requiredContainers',
                filterType: FilterType.Array,
            },
        ],
    }
}
